import React, { useState } from 'react';
import { TextField, Button, Box, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import SendIcon from '@material-ui/icons/Send';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: theme.spacing(1),
    padding: theme.spacing(1),
    backgroundColor: '#fff',
    borderTop: '1px solid #eee',
  },
  orangeFocused: {
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#FF7F27',
    },
    '& .MuiInputLabel-outlined.Mui-focused': {
      color: '#002D55',
    },
    '& .MuiInputLabel-outlined': {
      color: '#002D55',
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#FF7F27',
    },
  },
  sendButton: {
    color: '#FFFFFF',
    backgroundColor: '#002D55',
    borderRadius: 14,
    border: 'none',
    boxShadow: 'none',
    minWidth: 40,
    textTransform: 'none',
    flexShrink: 0,
    alignSelf: 'stretch',
    '&:hover': {
      backgroundColor: '#FF7F27',
      boxShadow: 'none',
    },
    '&.Mui-disabled': {
      backgroundColor: '#b0b8c1',
      color: '#fff',
    },
  },
  inputBase: {
    fontSize: 'clamp(0.72rem, 0.8vw, 0.875rem)',
  },
}));

export default function ChatInput({ onSendMessage, disabled = false, loading = false, value, onChange }) {
  const [internalMessage, setInternalMessage] = useState('');
  const classes = useStyles();

  // Use controlled mode if value/onChange provided, otherwise use internal state
  const isControlled = value !== undefined && onChange !== undefined;
  const currentMessage = isControlled ? value : internalMessage;
  const setCurrentMessage = isControlled ? onChange : setInternalMessage;

  const handleSend = () => {
    if (currentMessage.trim() && !loading) {
      onSendMessage(currentMessage);
      if (!isControlled) {
        setInternalMessage('');
      }
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey && !loading) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <Box className={classes.root}>
      <TextField
        className={classes.orangeFocused}
        placeholder="Type a message..."
        value={currentMessage}
        onChange={(e) => setCurrentMessage(e.target.value)}
        onKeyPress={handleKeyPress}
        multiline
        maxRows={4}
        variant="outlined"
        size="small"
        disabled={disabled || loading}
        fullWidth
        InputProps={{ style: { borderRadius: 14, fontSize: 'clamp(0.72rem, 0.8vw, 0.875rem)' } }}
        inputProps={{
          className: classes.inputBase,
          maxLength: 2000,
        }}
      />
      <Button
        variant="contained"
        className={classes.sendButton}
        onClick={handleSend}
        disabled={disabled || !currentMessage.trim() || loading}
        title="Send message"
      >
        {loading ? <CircularProgress size={20} color="inherit" /> : <SendIcon style={{ fontSize: 20 }} />}
      </Button>
    </Box>
  );
}
